import {
	RiEyeLine,
	RiFlagLine,
	RiGroup2Line,
	RiHeartLine,
	RiLiveLine,
	RiMicLine,
	RiMusic2Line,
	RiStarLine,
} from "@remixicon/react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@workspace/ui/components/select";
import { cn } from "@/lib/utils";

export type ReviewFilterType =
	| "all"
	| "want"
	| "must"
	| "saw-live"
	| "saw-stream"
	| "rated"
	| "following"
	| "loved";

interface ReviewFilterProps {
	value: ReviewFilterType;
	onValueChange: (value: string) => void;
	className?: string;
}

export const ReviewFilter = function ReviewFilterComponent({
	value,
	onValueChange,
	className,
}: ReviewFilterProps) {
	return (
		<Select value={value} onValueChange={onValueChange}>
			<SelectTrigger
				className={cn(
					"hover:bg-accent hover:text-accent-foreground active:scale-[0.99]",
					className,
				)}
			>
				<SelectValue placeholder="Filter reviews..." />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="all">
					<div className="flex items-center gap-2">
						<RiMusic2Line className="h-4 w-4" />
						All Sets
					</div>
				</SelectItem>
				<SelectItem value="want">
					<div className="flex items-center gap-2">
						<RiEyeLine className="h-4 w-4" />
						Want to See
					</div>
				</SelectItem>
				<SelectItem value="must">
					<div className="flex items-center gap-2">
						<RiFlagLine className="h-4 w-4" />
						Must See
					</div>
				</SelectItem>
				<SelectItem value="saw-live">
					<div className="flex items-center gap-2">
						<RiMicLine className="h-4 w-4" />
						Saw Live
					</div>
				</SelectItem>
				<SelectItem value="saw-stream">
					<div className="flex items-center gap-2">
						<RiLiveLine className="h-4 w-4" />
						Saw Stream
					</div>
				</SelectItem>
				<SelectItem value="following">
					<div className="flex items-center gap-2">
						<RiGroup2Line className="h-4 w-4" />
						Following
					</div>
				</SelectItem>
				<SelectItem value="rated">
					<div className="flex items-center gap-2">
						<RiStarLine className="h-4 w-4" />
						Rated
					</div>
				</SelectItem>
				<SelectItem value="loved">
					<div className="flex items-center gap-2">
						<RiHeartLine className="h-4 w-4" />
						Loved
					</div>
				</SelectItem>
			</SelectContent>
		</Select>
	);
};
